//@flow
import Constants from   '../constants';
import Dispatcher from '../dispatcher';
import type { FriendBuyVisitor } from '../Utils/friendbuyV2';
import type { AddressFields, AddressObject } from '../Stores/Addresses/addressModel';

export default {
  createCustomer(customerData:Object) {
    Dispatcher.dispatchAction(Constants.CREATE_CUSTOMER, customerData);
  },

  updateCustomer(data:Object) {
    Dispatcher.dispatchAction(Constants.UPDATE_CUSTOMER_DETAILS, data);
  },

  sendPasswordResetEmail(email:string) {
    Dispatcher.dispatchAction(Constants.SEND_PASSWORD_RESET_EMAIL, { email });
  },

  removeResetEmailNotice() {
    Dispatcher.dispatchAction(Constants.REMOVE_RESET_EMAIL_NOTICE);
  },

  removeExistingEmailError() {
    Dispatcher.dispatchAction(Constants.REMOVE_EXISTING_EMAIL_ERROR);
  },

  removeCustomerEmail(){
    Dispatcher.dispatchAction(Constants.REMOVE_CUSTOMER_EMAIL);
  },

  sendMagicLink(email:string) {
    Dispatcher.dispatchAction(Constants.SEND_MAGIC_LINK, { email });
  },

  removeMagicLinkNotice() {
    Dispatcher.dispatchAction(Constants.REMOVE_MAGIC_LINK_NOTICE);
  },

  addAddress(addressInfo:AddressFields) {
    Dispatcher.dispatchAction(Constants.ADD_ADDRESS, { addressInfo });
  },

  updateAddress(addressInfo:$Shape<AddressObject>, addressId:string) {
    Dispatcher.dispatchAction(Constants.UPDATE_ADDRESS, { addressInfo, addressId });
  },

  deleteAddress(addressId:string) {
    Dispatcher.dispatchAction(Constants.DELETE_ADDRESS, { addressId });
  },

  setEmailDomainValidationError(error:?string) {
    Dispatcher.dispatchAction(Constants.SET_EMAIL_DOMAIN_VALIDATION_ERROR, { error });
  },

  setFriendBuyData(data:FriendBuyVisitor) {
    Dispatcher.dispatchAction(Constants.SET_FRIENDBUY_DATA, data);
  },
};
